import { useNavigate } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";

import { getAllCategories, getAllBrands } from "../../reduxSaga/actions";
import { useSelector, useDispatch } from "react-redux";
import AddCategory from "../../ui/AddCategory";
import { useEffect, useState } from "react";
import EditCategory from "../../ui/EditCategory";

import Select from "react-select";
import { Alert } from "@material-ui/lab";
import { Snackbar } from "@mui/material";
import makeAnimated from "react-select/animated";
import SpecificityService from "../../services/SpecificityService";
import DataTableSpecificities from "./../../ui/DataTableSpecificities";

const SpecifitiesToCategory = () => {
  const dispatch = useDispatch();
  const availableCategories = useSelector(
    (state) => state.staff.availableCategories
  );
  const styles = {
    container: (base) => ({
      ...base,
      flex: 1,
    }),
  };

  const [availableSpecificity, setAvailableSpecificity] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const animatedComponents = makeAnimated();
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();

  const [oldCategoryData, setOldCategoryData] = useState();
  const [startDate, setStartDate] = useState("any");
  const [endDate, setEndDate] = useState("any");
  const [categoryId, setCategoryId] = useState(0);

  const [onAddCategory, setOnAddCategory] = useState(false);
  const [onEditCategory, setOnEditCategory] = useState(false);

  const [showElement, setShowElement] = useState([]);

  const [selectedOptionCategory, setSelectedOptionCategory] = useState(null);
  const [categorySelectPlaceHolder, setCategorySelectPlaceHolder] = useState(
    "Choisir une catégorie de produits"
  );
  const navigate = useNavigate();
  const [allCategories, setAllCategories] = useState([]);

  useEffect(() => {
    dispatch(getAllCategories(0));
    dispatch(getAllBrands(0));
  }, []);
  useEffect(() => {
    console.log("category",availableCategories)
    if (availableCategories === undefined || availableCategories.length === 0) {
      setCategoryId(0);
    }
    setAllCategories([]);
    availableCategories &&
      availableCategories.map((element, i) => {
        if (i === 0) {
          setCategoryId(element.id);
        }
        setAllCategories((oldArray) => [
          ...oldArray,
          {
            value: element.id,
            label:element.productFamilyName+"-"+element.productSubFamilyName+"-"+ element.name,
          },
        ]);
      });
  }, [availableCategories]);

  useEffect(() => {
    let user = JSON.parse(localStorage.getItem("user"));
    if (localStorage.getItem("status") == null) {
      setShowElement(["notConnected"]);
    } else {
      setShowElement(JSON.parse(localStorage.getItem("status")));
    }
  }, []);
  const onChangeSelectedCategory = (selectedOption) => {
    setSelectedOptionCategory();
    setCategoryId(selectedOption.value);
    setCategorySelectPlaceHolder(selectedOption.label);
  };
  useEffect(() => {
    if (startDate === ":59") {
      setStartDate("any");
    }
    if (endDate === ":59") {
      setEndDate("any");
    }
  }, [startDate, endDate]);

  const onAddCategoryHandler = () => {
    navigate(`/addSpecificityToCategory`);
  };

  const onGetProductsByFilter = () => {
    let idUserCreation = getCurrentUserId();
    let idCategory = categoryId;

    SpecificityService.getProductSpecificityByCategory(
      idUserCreation,
      idCategory
    ).then((response) => {
      if (response.data.length > 0) {
        setAvailableSpecificity(response.data);
        setShowTable(true);
      } else {
        setOpenErrorAlert(true);
        setErrorAlertText("Aucune spécificité dans cette catégorie ");
      }
    });
  };

  const filterTableProduct = () => {
    if (showTable && availableSpecificity.length > 0) {
      return (
        <DataTableSpecificities listSpecificities={availableSpecificity} />
      );
    }
  };
  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card  mt-3">
                <div class="card-body">
                  <h5 class="card-title">Les spécificités </h5>

                  {/* {!showElement.includes("WAREHOUSE_MANAGER") && ( */}
                  <button
                    class="btn btn-dark float-right"
                    onClick={onAddCategoryHandler}
                  >
                    <i class="fas fa-plus"></i>
                  </button>
                  {/* )} */}
                </div>
              </div>

              <div class="card  mt-3">
                <div class="card-body">
                  <div class="row">
                    <div className="form-group" class="col-sm-8">
                      <label>Choisir une catégorie</label>

                      <Select
                        styles={styles}
                        closeMenuOnSelect={true}
                        components={animatedComponents}
                        defaultValue={selectedOptionCategory}
                        onChange={onChangeSelectedCategory}
                        autosize={false}
                        options={allCategories}
                        placeholder={categorySelectPlaceHolder}
                      />
                
                    </div>
                    <div className="form-group" class="col-sm-4">
                      <br />
                      <button
                        class="btn btn-dark float-right"
                        onClick={onGetProductsByFilter}
                      >
                        Confirmer
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {filterTableProduct()}
            </div>
          </div>
        </div>
      </div>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>

      {onAddCategory && <AddCategory setOnAddCategory={setOnAddCategory} />}
      {onEditCategory && (
        <EditCategory
          setOnEditCategory={setOnEditCategory}
          oldCategoryData={oldCategoryData}
        />
      )}
    </div>
  );
};
export default SpecifitiesToCategory;
